export default __webpack_public_path__ + "static/media/20.3a7bec0d.jpeg";